import en from "./en.json";

export const resource = (key: string) => (en[key] ? en[key] : `{{${key}}}`);
